// 购买渠道
<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <!-- <img src="~@/assets/buy_img/stockvault.jpg"> -->
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title">
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png">
        <span class="place">您的位置：<span @click="goHome">主页</span>＞购买渠道</span>
      </div>
    </div>
    <div class="buy">
      <p class="address">淘宝店铺网址：<span id="taobao" @click="taobao()">
      https://shop442891054.taobao.com/?spm=a230r.7195193.1997079397.2.2a245b01cReiLN</span></p>
      <div class="buy-left">
        <img src="~@/assets/buy_img/taobao.jpg">
      </div>
      <div class="buy-right">
        <p>淘宝手机店铺二维码</p>
        <img src="~@/assets/buy_img/erweima.jpg">
      </div>
    </div>
  </div>
</template>
<script>
// import store from './store'
export default{
  name: 'buy',
  mounted () {
  },
  methods: {
    taobao () {
      window.open('https://shop442891054.taobao.com/?spm=a230r.7195193.1997079397.2.2a245b01cReiLN', '_blank')
    },
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    }
  }
}
</script>
<style scoped>
#taobao{
  cursor: pointer;
  /* color: #551A8B; */
}
@media screen and (min-width: 1500px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/buy_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 900px;
  margin-top: 25px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: 1%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 淘宝连接 */
.buy{
  width: 100%;
}
.address{
  margin-left: 15%;
  margin-top: 20px;
}
.buy-left{
  float: left;
  margin-top: 1%;
}
.buy-left img{
  width: 80%;
  height: 50%;
  margin-left: 32%;
}
.buy-right{
  float: right;
  margin-right: 20%;
  margin-top: 10%;
}
.buy p{
  font-size: 18px;
}
.buy-right p{
  font-size: 18px;
  /* margin-right: 10px; */
  text-align: center;
}
.buy-right img{
  width: 200%;
  height: auto;
  margin-right: 10%;
  margin-left: -45%;
}
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/buy_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 750px;
  margin-top: 20px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -3%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 淘宝连接 */
.buy{
  width: 100%;
}
.address{
  margin-left: 15%;
  margin-top: 20px;
}
.buy-left{
  /* float: left; */
  margin-top: 1%;
}
.buy-left img{
  width: 50%;
  height: auto;
  margin-left: 25%;
}
/* .buy-right{
  margin-top: 10%;
} */
.buy p{
  font-size: 16px;
}
.buy-right p{
  font-size: 1rem;
  text-align: center;
}
.buy-right img{
  width: 25%;
  height: auto;
  margin-left: 37.5%;
}
}
@media screen and (min-width: 960px) and (max-width:1199px){
/* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/buy_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 600px;
  /* margin-left: 20px; */
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -6%;
  margin-left: 14.5%;
  font-size: 16px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 淘宝连接 */
.buy{
  width: 100%;
}
.address{
  margin-left: 15%;
  margin-top: 20px;
}
.buy-left{
  /* float: left; */
  margin-top: 1%;
}
.buy-left img{
  width: 50%;
  height: auto;
  margin-left: 25%;
}
/* .buy-right{
  margin-top: 10%;
} */
.buy p{
  font-size: 16px;
}
.buy-right p{
  font-size: 1rem;
  text-align: center;
}
.buy-right img{
  width: 25%;
  height: auto;
  margin-left: 37.5%;
}
}
@media screen and (min-width: 768px) and (max-width:959px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/buy_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 400px;
  /* margin-left: 30px; */
  /* margin-top: 10px; */
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -11%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 淘宝连接 */
.buy{
  width: 100%;
}
.address{
  margin-left: 15%;
  margin-top: 20px;
}
.buy-left{
  /* float: left; */
  margin-top: 1%;
}
.buy-left img{
  width: 50%;
  height: auto;
  margin-left: 25%;
}
/* .buy-right{
  margin-top: 10%;
} */
.buy p{
  font-size: 16px;
}
.buy-right p{
  font-size: 1rem;
  text-align: center;
}
.buy-right img{
  width: 25%;
  height: auto;
  margin-left: 37.5%;
}
}
@media screen and (min-width: 702px) and (max-width:767px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/buy_img/stockvault.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 500px;
  margin-left: 50px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -12%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 淘宝连接 */
.buy{
  width: 100%;
}
.address{
  margin-left: 15%;
  margin-top: 20px;
}
.buy-left{
  /* float: left; */
  margin-top: 1%;
}
.buy-left img{
  width: 50%;
  height: auto;
  margin-left: 25%;
}
/* .buy-right{
  margin-top: 10%;
} */
.buy p{
  font-size: 16px;
}
.buy-right p{
  font-size: 1rem;
  text-align: center;
}
.buy-right img{
  width: 25%;
  height: auto;
  margin-left: 37.5%;
}
}
@media screen and (max-width:701px){
    .main{
    width: 100%;
    height: auto;
  }
      /* 顶部 */
.head{
  width: 100%;
  height: auto;
  background-image: url('~@/assets/buy_img/stockvault.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title{
  width: 50%;
  margin-left: 30%;
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  margin-top: 10px;
  margin-left: 10%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 6%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 淘宝连接 */
.buy{
  width: 100%;
}
.address{
  margin-left: 15%;
  margin-top: 20px;
}
.buy-left{
  float: left;
  margin-top: 1%;
}
.buy-left img{
  width: 80%;
  height: 50%;
  margin-left: 10%;
}
/* .buy-right{
  margin-top: 10%;
} */
.buy p{
  font-size: 0.8rem;
}
.buy-right p{
  font-size: 1rem;
  text-align: center;
}
.buy-right img{
  width: 50%;
  height: auto;
  margin-left: 25%;
}
}

</style>



// WEBPACK FOOTER //
// src/components/buy/buy.vue